import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalBody,
  Button,
  ModalHeader,
  Label,
  ModalFooter,
  Input,
  Alert,
} from "reactstrap";
import { connect } from "react-redux";
import moment from "moment";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import * as actionCreators from "../../../modules/actions/index";
import Loading from "../../../hoc/Loading/Loading";
import { FaArrowRight } from "react-icons/fa6";
import Select from "react-select";
import { BiEditAlt, BiX } from "react-icons/bi";
import {
  isUrlValid,
  uploadPreview,
  wikimediaAuth,
  triviaCategoryAPI,
  triviaListCategories,
} from "../../../utils/constants";
import { withRouter } from "react-router-dom";
import { toastContainer } from "../../../utils/toast";
// FaUber
import { FaUber } from "react-icons/fa";
import DatePicker from "react-datepicker";

export default function RewardDeleteModal({
  data,
  handleAfterDelete,
  open,
  onClose,
}) {




  const handleDelete=()=>{

    axios.delete(url.deleteReward(data._id)).then(({data})=>{
        toastContainer("Deleted successfully","success")
        handleAfterDelete(data.data)
    }).catch(err =>{
        toastContainer("Error while deleting","error")
    })
  }
  return (
    <Modal isOpen={open}>
      <ModalHeader         className="trivia_modal_header_bg" toggle={onClose}>Edit reward</ModalHeader>
      <ModalBody>
        
        <h5>
            {data && data.rewardName ? <div>Are you sure you want to delete reward {data.rewardName}? </div> :""}
        </h5>
      </ModalBody>

      <ModalFooter>

      <Button  className="mr-4 btn-success" onClick={onClose}>
          Cancel 
        </Button>
        <Button color="danger" className="mr-4 btn-success" onClick={() => {handleDelete()}}>
          Delete 
        </Button>
      </ModalFooter>
    </Modal>
  );
}
